exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".previews .search-header h1{color:#006aff;font-size:3em;font-weight:500}.previews p.type-explanation{font-size:16px;margin-bottom:5px}.previews .type-card{background:#eaf7fc;padding:30px}", ""]);

// exports
